<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a class="accordion-toggle collapsed" data-toggle="collapse" v-bind:href="randomDeviceHref(item.userId)" aria-expanded="true" @click="getData(item.userId)">
          <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
          &nbsp;デバイス
        </a>
      </h4>
    </div>
    <div class="panel-collapse collapse" :id="randomDeviceClass(item.userId)" aria-expanded="true">
      <div class="panel-body">
        <h3 class="table-title">スマートフォン</h3>
        <table style="min-width:100%" class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th>スマートフォンID</th>
              <th>端末名</th>
              <th class="hidden-480 center">ステータス</th>
              <th class="hidden-480 center">登録日</th>
            </tr>
          </thead>
          <tbody v-if="listphones!=null">
            <template v-for="(item, index) in listphones">
              <tr :key="index">
                <td><a class="link" @click="viewPhone(item.phoneId)">{{item.phoneId}}</a></td>
                <td>{{item.model}}</td>
                <td class="center">{{item.status}}</td>
                <td class="center">{{converDate(item.registered)}}</td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">データーはありません</td>
            </tr>
          </tbody>
        </table>
        <h3 class="table-title">個人コード</h3>
        <table style="min-width:100%" class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th>個人コードID</th>
              <th class="center">個人コード種別</th>
              <th class="hidden-480 center">ステータス</th>
              <th class="hidden-480 center">登録日</th>
            </tr>
          </thead>
          <tbody v-if="listPDevice!=null">
            <template v-for="(item, index) in listPDevice">
              <tr :key="index">
                <td><a class="link" @click="viewPcode(item.pCodeId)">{{item.pCodeId}}</a></td>
                <td class="center">{{item.type}}</td>
                <td class="center">
                  <span v-if="item.isValid">有効</span>
                  <span v-else >無効</span>
                </td>
                <td class="center">{{converDate(item.registered)}}</td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">データーはありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  props: ['item', 'userId'],
  data () {
    return {
      listphones: null,
      listPDevice: null
    }
  },
  methods: {
    viewPhone (id) {
      let routeData = this.$router.resolve({name: 'phoneedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    viewPcode (id) {
      let routeData = this.$router.resolve({name: 'pcodeedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    getData (userId) {
      this.listphones = null
      this.getInforDevice(userId)
      this.listPDevice = null
      this.getInforPDevice(userId)
    },
    // スマートフォン取得
    getInforDevice (userId) {
      this.$http.get(Config.PHONES_LIST_API + '?userId=' + encodeURIComponent(userId) + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.listphones = response.body.phones
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // NFC読み取り設定種別取得
    getTypeInfo (type, i) {
      var vm = this
      if (type === 0) {
        vm.listPDevice[i].type = 'NFCカード'
      } else {
        vm.listPDevice[i].type = 'テンキー入力'
      }
    },
    // 個人コード取得
    getInforPDevice (userId) {
      var vm = this
      this.$http.get(Config.PCODE_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.listPDevice = response.body.pCodes
            for (var i = 0; i < vm.listPDevice.length; i++) {
              vm.getTypeInfo(vm.listPDevice[i].type, i)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomDeviceClass (classname) {
      return 'device' + this.removeSpecialSymboy(classname)
    },
    randomDeviceHref (classname) {
      return '#device' + this.removeSpecialSymboy(classname)
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/UserDetailDevice.vue